<div class="fixed top-0 right-0 left-0 transition-all h-auto z-[5] py-[10px] bg-gray-300 dark:bg-gray-900"
     id="navbar"
     [ngClass]="{'is-sticky': isSticky}">
    <div class="container 2xl:max-w-[1320px] mx-auto px-[12px]">
        <div class="flex items-center relative flex-wrap lg:flex-nowrap justify-between lg:justify-start">
            <a routerLink="/" class="inline-block max-w-[130px] ltr:mr-[15px] rtl:ml-[15px] ">
                @if(isSticky || _toggleThemeService.isDark()){
                    <img src="images/logo_loomisFx_dark.png" alt="logo" class="max-h-[110px] max-w-[88px]">
                }
                @else {
                    <img src="images/logo_loomisFx.png" alt="logo" class="inline-block dark:hidden max-h-[110px] max-w-[88px]">
                }
            </a>

            <button type="button"
                    id="navbar-burger-menu"
                    (click)="toggleClass()"
                    [class.active]="classApplied"
                    class="inline-block relative leading-none lg:hidden">
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white"></span>
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white"></span>
                <span class="h-[3px] w-[30px] my-[5px] block bg-black dark:bg-white"></span>
            </button>

            <div class="hidden lg:flex items-center grow basis-full basis-auto">
                <!-- For Big Devices -->
                <ul class="navbar-nav flex ltr:ml-[30px] rtl:mr-[30px] ltr:xl:ml-[55px] rtl:xl:mr-[55px] flex-row gap-[30px] xl:gap-[50px]">
                    <li>
                        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600 text-[15px] xl:text-md">
                            <!--i18n: Home -->
                            {{ 'i18n.app.features.pages.order.common.order-navbar.a_01' | translate }}
                        </a>
                    </li>
                    <li>
                        <widget-language-switcher></widget-language-switcher>
                    </li>
                    <li>
                        <widget-theme-switcher></widget-theme-switcher>
                    </li>
                </ul>
            </div>
            <div id="navbar-collapse"
                 [class.active]="classApplied"
                 class="bg-white dark:bg-black mt-[20px] p-[20px] md:p-[30px] w-full hidden lg:!hidden">
                <!-- For Resposive -->
                <ul class="navbar-nav">
                    <li class="my-[14px] md:my-[16px] first:mt-0 last:mb-0">
                        <a routerLink="/" routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}" class="font-medium text-gray-500 dark:text-gray-400 transition-all hover:text-primary-600">
                            <!--i18n: Home -->
                            {{ 'i18n.app.features.pages.order.common.order-navbar.a_02' | translate }}
                        </a>
                    </li>
                    
                    <li>
                        <widget-language-switcher></widget-language-switcher>
                    </li>
                    <li>
                        <widget-theme-switcher></widget-theme-switcher>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</div>